import { render, staticRenderFns } from "./coach_routines.vue?vue&type=template&id=6d3a3d0f&scoped=true"
import script from "./coach_routines.vue?vue&type=script&lang=js"
export * from "./coach_routines.vue?vue&type=script&lang=js"
import style0 from "./coach_routines.vue?vue&type=style&index=0&id=6d3a3d0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3a3d0f",
  null
  
)

export default component.exports